import React from 'react';
import { Empty, Spin } from 'antd';
import { keepTwoOrLine, keepTwoAndWanOrLine } from '@/utils/utils';
import { V2HighEnergyDeviceAnalysisV2EnergyTrendPostResponse } from '@maxtropy/device-customer-apis-v2';
import styles from './index.module.scss';

export interface EnergyOverviewProps {
  totalEnergy?: number;
  peakEnergy?: number;
  peakRate?: number;
  flatEnergy?: number;
  flatRate?: number;
  valleyEnergy?: number;
  valleyRate?: number;
  sharpEnergy?: number;
  sharpRate?: number;
}

export interface EnergyOverviewWithApiProps {
  data?: V2HighEnergyDeviceAnalysisV2EnergyTrendPostResponse;
  energyTrendLoading: boolean;
}

const EnergyOverview: React.FC<EnergyOverviewWithApiProps> = ({ data, energyTrendLoading }) => {
  const totalEnergy = keepTwoAndWanOrLine(data?.totalConsumption);
  const totalCost = keepTwoAndWanOrLine(data?.totalCost);
  const sharpEnergy = keepTwoAndWanOrLine(data?.summitConsumption);
  const sharpRate = keepTwoOrLine(data?.summitPercentage);
  const sharpCost = keepTwoAndWanOrLine(data?.summitCost);
  const peakEnergy = keepTwoAndWanOrLine(data?.peakConsumption);
  const peakRate = keepTwoOrLine(data?.peakPercentage);
  const peakCost = keepTwoAndWanOrLine(data?.peakCost);
  const flatEnergy = keepTwoAndWanOrLine(data?.plainConsumption);
  const flatRate = keepTwoOrLine(data?.plainPercentage);
  const flatCost = keepTwoAndWanOrLine(data?.plainCost);
  const valleyEnergy = keepTwoAndWanOrLine(data?.valleyConsumption);
  const valleyRate = keepTwoOrLine(data?.valleyPercentage);
  const valleyCost = keepTwoAndWanOrLine(data?.valleyCost);

  const timePeriodData = [
    { key: 'sharp', label: '尖时段用能', value: sharpEnergy, rate: sharpRate, cost: sharpCost, color: '#FF6D2C' },
    { key: 'peak', label: '峰时段用能', value: peakEnergy, rate: peakRate, cost: peakCost, color: '#CE90D1' },
    { key: 'flat', label: '平时段用能', value: flatEnergy, rate: flatRate, cost: flatCost, color: '#0DB6D9' },
    { key: 'valley', label: '谷时段用能', value: valleyEnergy, rate: valleyRate, cost: valleyCost, color: '#63BC7F' },
  ];

  return (
    <div className={styles.energyOverview}>
      {energyTrendLoading ? (
        <Spin spinning></Spin>
      ) : (
        <>
          <div className={styles.totalCard}>
            <span className={styles.label}>总用能 (kWh)</span>
            <span className={styles.value}>{totalEnergy}</span>
            <div className={styles.costRow}>
              <span className={styles.costLabel}>用能成本：</span>
              <span className={styles.costValue}>{totalCost}元</span>
            </div>
          </div>
          {timePeriodData.map(item => (
            <div className={styles.periodCard} key={item.key}>
              <div className={styles.colorBar} style={{ backgroundColor: item.color }} />
              <div className={styles.content}>
                <div className={styles.row}>
                  <span className={styles.periodLabel}>{item.label} (kWh)</span>
                  <span className={styles.rate} style={{ color: item.color }}>
                    {item.rate}%
                  </span>
                </div>
                <span className={styles.value}>{item.value}</span>
                <div className={styles.costRow}>
                  <span className={styles.costLabel}>用能成本：</span>
                  <span className={styles.costValue}>{item.cost}元</span>
                </div>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default EnergyOverview;
